import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NewsContentService } from 'src/app/core/home-banner/services/news-content.service';
import { FilterDto } from 'src/app/shared/models/filter';
@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss']
})
export class ArchiveComponent {
  @Input() newsData: any
  Items: any = [];
  filter: FilterDto = new FilterDto()
  constructor(
    private _NewsContentService: NewsContentService,
  ) {
  
    this.getContent('')
  }

  getContent(filter:any){
    this._NewsContentService.watch(
      {
        filter:filter,
        skip:this.filter.skip,
        top:this.filter.top
      }
    ).valueChanges.subscribe((result: any) => {
      this.Items = result.data.queryNewsContents;
      console.log("martinaNews", this.Items)
    });
  }


  filterEvent(filterEvent:FormGroup){
    

    let  {search,fromtodate} = filterEvent.value;
    const [fromDate, toDate] = fromtodate || [null, null];


      function filterQueryBuilder() {
      let filter = '';

      if ((search != null)&&(search?.length > 0)) {
        filter += filter && filter.length > 0 ? ' and ' : '';
        filter += `(contains(data/newsTitle/${sessionStorage.getItem('currentlang')}, '${search}') )`;
      }
  
 
      return filter;
    }

    console.log("snlffnsdlds",filterEvent)
    this.getContent(filterQueryBuilder());

 

  }

}
